import walidacjaStanu from '@components/form/validation/field/stan'
import validated from '@components/form/validation/validated'

export default validated({
    name: 'stan',
    options: ['Nowy', 'Uzywany'],
    tOptions: ['Nowy', 'Używany'],

}, walidacjaStanu)